<template>
	<div class="doctor_list_row">
		<base-search v-model="doctorName" @input="search" placeholder="请输入医生姓名"> </base-search>
		<van-dropdown-menu class="doctor-dropdown-style" active-color="#00BCD1">
			<van-dropdown-item title="科室" ref="item">
				<tree-select
					:options="departmentList"
					:mainActiveIndex.sync="departmentIndex"
					:activeId.sync="departmentName"
					@change="onChange('item')"
				/>
			</van-dropdown-item>
			<van-dropdown-item title="地区" ref="item2">
				<tree-select
					@change="onChange('item2')"
					:options="citys"
					:mainActiveIndex.sync="mainActiveIndex"
					:activeId.sync="cityId"
				/>
			</van-dropdown-item>
		</van-dropdown-menu>
		<div class="p-32">
			<van-list
				v-model="loading"
				:finished="finished"
				:finished-text="
                    dataList.length === 0 ? '未搜到相关医生' : '没有更多了'
                "
				@load="onLoad"
			>
				<doctor-item
					v-for="(item,index) in dataList"
					:haveMore="false"
					:doctor="item"
					:key="index"
					@click="$router.push(`/physicianVisits/scheduleDetail/${item.id}?type=${$route.query.type}`)"
				/>
			</van-list>
		</div>
	</div>
</template>
<script>
import treeSelect from './components/tree-select.vue'
import doctorItem from './components/doctor-item.vue'
export default {
    name: 'doctorList',
    components: { doctorItem, treeSelect },
    data () {
        return {
            doctorName: '',
            dataList: [],
            citys: [],
            departmentList: [],
            mainActiveIndex: 0,
            cityId: "",
            departmentIndex: 0,
            departmentName: "",
            page: 1,
            limit: 20,
            loading: true,
            finished: true,
        }
    },
    computed: {
        interrogationType () {
            return this.$route.query.type
        }
    },
    created () {
        this.getCityList()
        this.getDataList()
        this.getDepartmentList()
    },
    methods: {
        onChange (ref) {
            this.page = 1
            this.dataList = []
            this.getDataList();
            this.$refs[ref].toggle();
        },
        onLoad () {
            this.page += 1
            this.getDataList();
        },
        getDepartmentList () {
            this.$api.sys.getDepartmentList({}).then(({ data }) => {
                const department =
                    data.map(v => ({
                        ...v,
                        id: v.name,
                        children: v.respBodyList.length > 0
                            ? v.respBodyList.map(s => ({
                                ...s,
                                id: s.name,
                                children: s.respBodyList.length > 0
                                    ? s.respBodyList.map(x => ({
                                        ...x,
                                        id: x.name,
                                    }))
                                    : []
                            }))
                            : [{ id: v.name, name: v.name, children: [] }]
                    }))
                department.unshift({
                    name: "全部科室",
                    id: "",
                    children: [{ name: "全部", id: "", children: [] }]
                })
                this.departmentList = department;
            })
        },
        getCityList () {
            this.$api.address.regionTree({}).then(({ data }) => {
                this.citys = [
                    {
                        name: "全国",
                        id: "",
                        children: [{ name: "全国", id: "" }]
                    }
                ].concat(
                    data.map(v => ({
                        ...v,
                        children: [{ name: "全部", id: "" }].concat(v.child)
                    }))
                );
            })
        },
        search () {
            this.page = 1
            this.dataList = []
            this.mainActiveIndex = 0
            this.cityId = ""
            this.departmentIndexx = 0
            this.departmentName = ""
            this.getDataList();
        },
        getDataList () {
            let province = this.citys[this.mainActiveIndex];
            this.loading = true
            this.finished = false
            console.log(this.$api.doctor)
            this.$api.doctor.getDoctorList({
                departmentName: this.departmentName,
                provinceId: province ? province.id : "",
                cityId: this.cityId,
                page: this.page,
                limit: this.limit,
                doctorName: this.doctorName,
                interrogationType: this.interrogationType
            }, true)
                .then(({ code, data }) => {
                    if (!code) {
                        this.dataList = this.dataList.concat(data.map(v => ({
                            ...v,
                            deptName: v.departmentName,
                            title: v.titleName,
                            expertise: v.expertiseField
                        })));
                        this.loading = false
                        this.finished = true
                    }
                    console.log(data)

                });

        }
    }
}
</script>
<style lang="less" scoped>
.doctor_list_row {
}
</style>